<template>
  <div id="senior-member-not-paid-bulk-payment" class="pa-4">
    <v-overlay :value="ProgressLoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Header Banner -->
    <div class="banner-header">
      <div class="banner-circle banner-circle-1"></div>
      <div class="banner-circle banner-circle-2"></div>
      <div class="banner-title">
        <h1 class="page-title">{{ PageTitle }}</h1>
        <p
          class="mt-2 mb-0"
          style="
            color: rgba(255, 255, 255, 0.9);
            font-size: 15px;
            font-weight: 400;
            letter-spacing: 0.3px;
          "
        >
          Search JAC members who have not paid for the selected year and
          pay for the selected members in a single payment.
        </p>
      </div>
      <v-btn fab class="refresh-btn" @click="refreshPageData()" elevation="0">
        <v-icon size="28">mdi-refresh</v-icon>
      </v-btn>
    </div>

    <!-- Loading Spinner -->
    <div class="d-flex justify-content-center mb-6" v-if="LoadingFlag">
      <b-spinner variant="primary" type="grow" label="Loading..."></b-spinner>
    </div>

    <!-- Search Form -->
    <v-card class="search-card" v-if="!LoadingFlag">
      <v-card-text>
        <v-form ref="form2" v-model="valid1" lazy-validation>
          <v-row wrap class="align-center">
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="input-label">
                <v-icon>mdi-calendar</v-icon>
                <span class="text-danger mr-1">*</span> Year
              </div>
              <v-autocomplete
                :reduce="(option) => option.value"
                :items="JciYearCodeOptions"
                :rules="JciYearCodeRules"
                :loading="JciYearCodeOptionsLoading"
                v-model="JciYearCode"
                placeholder="Select year"
                dense
                outlined
                hide-details
                background-color="#FFFFFF"
                class="rounded-lg"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="input-label">
                <v-icon>mdi-map-marker-outline</v-icon>
                <span class="text-danger mr-1">*</span> Zone
              </div>
              <v-autocomplete
                :reduce="(option) => option.value"
                :items="ZoneCodeOptions"
                :rules="ZoneCodeRules"
                :loading="ZoneCodeOptionsLoading"
                v-model="ZoneCode"
                placeholder="Select zone"
                dense
                clearable
                outlined
                hide-details
                background-color="#FFFFFF"
                class="rounded-lg"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="input-label">
                <v-icon>mdi-account-group-outline</v-icon>
                LO <small>(Optional)</small>
              </div>
              <v-autocomplete
                :reduce="(option) => option.value"
                v-model="LomCode"
                :items="LomCodeOptions"
                :loading="LomCodeOptionsLoading"
                placeholder="Select LO"
                dense
                clearable
                outlined
                hide-details
                background-color="#FFFFFF"
                class="rounded-lg"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" lg="2" md="2">
              <div class="input-label" style="visibility: hidden">&nbsp;</div>
              <v-btn
                :disabled="!valid1"
                @click.prevent="searchForm"
                :loading="SearchFlag"
                class="search-btn"
                style="min-width: 130px; font-size: 16px; height: 40px"
              >
                <v-icon left size="20" color="white">mdi-magnify</v-icon>
                Search
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- Empty State -->
    <div class="text-center py-10" v-if="ResultFlag && rows.length == 0">
      <h4 class="text-muted font-weight-bold">
        No unpaid members found for the selected filters.
      </h4>
    </div>

    <!-- Results Table -->
    <v-card
      class="result-card elevation-4 rounded-xl border-0"
      v-if="rows.length > 0"
    >
      <v-card-title
        class="px-6 pt-6 pb-2 d-flex justify-space-between align-center flex-wrap"
      >
        <div>
          <h3 class="mb-0 text-h6 font-weight-bold" style="color: #0a0f29">
            {{ rows.length }} not-paid member(s) found
          </h3>
          <div class="mt-1" style="color: #414042; font-size: 13px">
            {{ selected.length }} selected
            <span v-if="selected.length > 0">
              &mdash; Total: Rs. {{ selectedTotal }}
            </span>
          </div>
        </div>
        <div class="d-flex align-center flex-wrap">
          <v-btn
            :disabled="selected.length === 0 || !ZoneCode"
            @click.prevent="confirmAlert"
            :loading="SubmitFlag"
            color="#56BDA3"
            elevation="0"
            class="rounded-lg text-white ml-3"
            style="height: 40px; font-weight: 600; text-transform: none"
          >
            <v-icon left>mdi-cash-multiple</v-icon>
            Bulk Payment
          </v-btn>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search records here"
            single-line
            hide-details
            outlined
            dense
            class="rounded-lg ml-3"
            style="
              max-width: 300px;
              background-color: #ffffff;
              border: 1px solid #0097d7;
            "
          ></v-text-field>
        </div>
      </v-card-title>
      <v-card-text class="pa-2 px-md-4">
        <div
          class="px-3 pb-2"
          style="color: #ea5455; font-size: 12px"
          v-if="selected.length > 0 && !ZoneCode"
        >
          Kindly select a Zone in the filters above before making a bulk
          payment.
        </div>
        <v-data-table
          class="custom-table elevation-0"
          loading-text="Loading... Please wait"
          v-model="selected"
          :search="search"
          :show-select="tableOptions1.ShowSelectFlag"
          :loading="TableLoadingFlag"
          :item-key="tableOptions1.ItemKey"
          :single-select="tableOptions1.SingleSelectFlag"
          :headers="tableColumns1"
          :items="rows"
          :items-per-page="tableOptions1.ItemsPerPage"
          :footer-props="tableOptions1.FooterProps"
        >
          <template v-slot:[`item.ProfilePic`]="{ item }">
            <v-avatar size="48" class="my-2 elevation-1">
              <img :src="item.ProfilePic" alt="Profile" />
            </v-avatar>
          </template>

          <template v-slot:[`item.MemberDetailsTxt`]="{ item }">
            <div class="d-flex flex-column py-2" style="max-width: 180px">
              <span
                class="font-weight-bold"
                style="color: #0a0f29; font-size: 13px; white-space: normal"
                >{{ item.MemberName }}</span
              >
              <span
                class="mt-1"
                style="color: #414042; font-size: 12px; white-space: normal"
                >{{ item.MembershipId }}</span
              >
            </div>
          </template>

          <template v-slot:[`item.RegionLomTxt`]="{ item }">
            <div class="d-flex flex-column py-2" style="max-width: 200px">
              <span
                class="font-weight-bold"
                style="color: #0a0f29; font-size: 13px; white-space: normal"
                >{{ item.RegionName }}</span
              >
              <span
                class="mt-1"
                style="color: #414042; font-size: 12px; white-space: normal"
                >{{ item.LomName }}</span
              >
            </div>
          </template>

          <template v-slot:[`item.TotalAmount`]="{ item }">
            Rs. {{ item.TotalAmount }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  data() {
    return {
      valid1: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ProgressLoadingFlag: false,
      ResultFlag: false,
      TableLoadingFlag: false,

      rows: [],
      tableColumns1: [],
      tableOptions1: [],
      selected: [],
      search: "",

      Order: {},

      JciYearCode: "",
      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      ZoneCode: "",
      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      RegionCode: "",
      RegionCodeOptions: [],
      RegionCodeOptionsLoading: false,

      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      RoleId: "",
    };
  },
  computed: {
    selectedTotal() {
      var total = this.selected.reduce(function (sum, item) {
        var amount = parseFloat(item.TotalAmount);
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);
      return this.getDecimalNumber(total, 2);
    },
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      var n1 = Object.keys(tr).length;
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        this.CurrentYearId = CurrentJciYearId;
        this.JciYearCode = CurrentJciYearId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        this.RoleId = RoleId;

        this.getJciYearCodeOptions();
        this.getZoneCodeOptions();
      }
    },
    JciYearCodeOptions: function () {
      this.JciYearCodeOptionsLoading = false;
    },
    ZoneCodeOptions: function () {
      this.ZoneCodeOptionsLoading = false;
    },
    LomCodeOptions: function () {
      this.LomCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      this.getRegionCodeOptions();
      this.getLomCodeOptions();
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "senior_members_bulk_payment",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    getJciYearCodeOptions() {
      console.log("getJciYearCodeOptions called");
      this.JciYearCodeOptionsLoading = true;
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 3,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      this.ZoneCodeOptionsLoading = true;
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/year-wise-lom/zone-options-v2";
      var selectbox1_conditions_array = {
        UserInterface: 9,
        YearCode: this.CurrentYearId,
        NotAvailable: 1,
        AllZones: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getRegionCodeOptions() {
      console.log("getRegionCodeOptions called");
      this.RegionCodeOptionsLoading = true;
      var selectbox1_source = "RegionCode";
      var selectbox1_destination = "RegionCodeOptions";
      var selectbox1_url = "api/jac-region/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
        Zone: this.ZoneCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      if (this.CurrentYearId != "" && this.ZoneCode != "") {
        this.LomCode = "";
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 3,
          YearCode: this.CurrentYearId,
          ZoneCode: this.ZoneCode,
          AllOption: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    searchForm() {
      console.log("searchForm is called");

      var validate1 = this.$refs.form2.validate();

      if (validate1) {
        this.SearchFlag = true;
        this.TableLoadingFlag = true;
        this.rows = [];
        this.selected = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/senior/members/not-paid-bulk-payment/list";
        var upload = {
          UserInterface: 1,
          Year: this.JciYearCode,
          Zone: this.ZoneCode,
          Lom: this.LomCode,
        };

        const thisIns = this;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SearchFlag = false;
            thisIns.TableLoadingFlag = false;
            thisIns.ResultFlag = true;

            var output = response.data.output;
            var flag = response.data.flag;
            var records = response.data.records;

            if (flag == 1) {
              thisIns.tableOptions1 = records.TableOptions;
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.rows = records.TableData;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
            thisIns.TableLoadingFlag = false;
          });
      } else {
        this.toast("error", "Kindly fill the required fields");
      }
    },
    confirmAlert() {
      var selected = this.selected;

      if (selected.length > 0 && this.ZoneCode) {
        var htmlTxt = "";
        htmlTxt += "<br/><b>" + selected.length + " member(s) selected</b>";
        htmlTxt += "<br/>Total amount <b>Rs. " + this.selectedTotal + "</b>";
        htmlTxt += "<br/><br/>Do you want to continue to payment?";

        Swal.fire({
          title: "Please verify all the information before proceeding",
          text: "",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#56BDA3",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#414042",
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.sweetAlert(
          "error",
          "Kindly select a Zone, a Region, and at least one member to continue.",
          false
        );
      }
    },
    submitForm() {
      console.log("submitForm is called");

      this.SubmitFlag = true;
      this.ProgressLoadingFlag = true;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/senior/members/not-paid-bulk-payment/create";

      var upload = {
        UserInterface: 1,
        Year: this.JciYearCode,
        Zone: this.ZoneCode,
        Region: this.RegionCode,
        MemberIds: this.selected.map((item) => item.MemberId),
        TotalAmount: this.selectedTotal,
      };

      const thisIns = this;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SubmitFlag = false;
          thisIns.ProgressLoadingFlag = false;

          var output = response.data.output;
          var flag = response.data.flag;
          var records = response.data.records;

          if (flag == 1) {
            thisIns.Order = records.Order;
            thisIns.makePayment();
          } else {
            thisIns.sweetAlert("info", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SubmitFlag = false;
          thisIns.ProgressLoadingFlag = false;
        });
    },
    makePayment() {
      console.log("makePayment");
      var order = this.Order;
      const thisIns = this;
      var rzp1 = new Razorpay({
        key: order.rzp_key,
        account_id: order.rzp_account_id,
        order_id: order.rzp_order_id,
        amount: order.rzp_amount,
        name: order.rzp_name,
        currency: "INR",
        description: order.rzp_description,
        image: order.rzp_image,
        theme: {
          color: order.rzp_color,
        },
        prefill: {
          name: order.customer_name,
          email: order.customer_email_id,
          contact: order.customer_mobile_no,
        },
        notes: {
          address: "",
        },
        redirect: false,
        handler: function (response) {
          console.log("razorpay_payment_id=" + response.razorpay_payment_id);
          thisIns.sweetAlert("success", "Payment successful!", false);
          thisIns.searchForm();
        },
        modal: {
          ondismiss: function () {
            console.log("Razorpay checkout dismissed");
            thisIns.SubmitFlag = false;
          },
        },
      });
      rzp1.open();
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
#senior-member-not-paid-bulk-payment {
  background-color: transparent;

  .banner-header {
    background: linear-gradient(135deg, #3a67b1 0%, #0097d7 100%);
    box-shadow: 0 10px 25px rgba(58, 103, 177, 0.2);
    position: relative;
    overflow: hidden;
    padding: 2.5rem 3rem;
    border-radius: 20px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .banner-circle {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.05);
    }
    .banner-circle-1 {
      width: 400px;
      height: 400px;
      top: -200px;
      right: -100px;
    }
    .banner-circle-2 {
      width: 250px;
      height: 250px;
      bottom: -100px;
      right: 250px;
    }

    .banner-title {
      position: relative;
      z-index: 1;
      .page-title {
        color: #ffffff;
        font-size: 2.25rem;
        font-weight: 700;
        margin: 0;
        letter-spacing: -0.5px;
      }
    }

    .refresh-btn {
      background: rgba(255, 255, 255, 0.15) !important;
      color: #ffffff !important;
      backdrop-filter: blur(8px);
      width: 56px;
      height: 56px;
      position: relative;
      z-index: 1;
      &:hover {
        background: rgba(255, 255, 255, 0.25) !important;
        transform: rotate(90deg);
        transition: transform 0.4s ease;
      }
      transition: all 0.3s ease;
    }
  }

  .search-card,
  .result-card {
    border-radius: 20px !important;
    box-shadow: 0 10px 40px rgba(10, 15, 41, 0.05) !important;
  }

  .search-card {
    .search-btn {
      background: #edbe38 !important;
      color: #0a0f29 !important;
      font-weight: 700;
      text-transform: none;
      border-radius: 22px !important;
      letter-spacing: 0.5px;
      height: 44px !important;
      border: none !important;
      box-shadow: 0 8px 20px rgba(237, 190, 56, 0.4) !important;
      transition: all 0.3s ease;

      &:hover {
        background: #edbe38 !important;
        transform: translateY(-2px);
        box-shadow: 0 10px 25px rgba(237, 190, 56, 0.5) !important;
      }
    }

    .input-label {
      font-size: 0.85rem;
      font-weight: 600;
      color: #414042;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      .v-icon {
        font-size: 16px;
        margin-right: 6px;
        color: #0097d7;
      }
      small {
        margin-left: 4px;
        color: #414042;
        font-weight: 400;
      }
    }
  }

  ::v-deep .custom-table {
    border-radius: 12px;
    overflow: hidden;

    th {
      font-weight: 700 !important;
      color: #ffffff !important;
      text-transform: uppercase;
      font-size: 13px !important;
      letter-spacing: 0.5px;
      background-color: #3a67b1 !important;
      border-bottom: 1px solid #3a67b1 !important;
      padding: 12px 8px !important;
      white-space: normal !important;
      vertical-align: middle !important;
    }
    td {
      border-bottom: 1px solid #3a67b1 !important;
      padding: 8px 8px !important;
    }
  }
}
</style>
